var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErroricon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5745 0.249512C5.19837 0.249512 0.824463 4.62342 0.824463 9.99951C0.824463 15.3756 5.19837 19.7495 10.5745 19.7495C15.9506 19.7495 20.3245 15.3756 20.3245 9.99951C20.3245 4.62342 15.9506 0.249512 10.5745 0.249512ZM11.512 15.2453H9.63696V13.3703H11.512V15.2453ZM11.3245 12.2495H9.82446L9.54321 4.74951H11.6057L11.3245 12.2495Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroricon);
export default __webpack_public_path__ + "static/media/erroricon.3d0089086878b135bfa7a13c44ff03ce.svg";
export { ForwardRef as ReactComponent };